import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {addMessageBoxInfo} from '../../common/messageBox/actions/actions';

export const fetchTechniciansGroups = () => {
  return apiActionCreator({
    'endpoint': '/accessories/technician-groups',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_TECHNICIAN_GROUPS,
      ActionTypes.FETCHED_TECHNICIAN_GROUPS,
      [
        ActionTypes.FETCHED_TECHNICIAN_GROUPS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchTechnicianGroupByGroup = (groupId) => {
  return apiActionCreator({
    'endpoint': `/accessories/technicians/${groupId}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_TECHNICIAN_GROUP_INFO,
      ActionTypes.FETCHED_TECHNICIAN_GROUP_INFO,
      [
        ActionTypes.FETCHED_TECHNICIAN_GROUP_INFO_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const addNewTechnicianGroup = (data) => {
  return apiActionCreator({
    'endpoint': '/accessories/technician-groups',
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_TECHNICIAN_GROUP,
      [
        ActionTypes.ADDED_TECHNICIAN_GROUP,
        addMessageBoxInfo('El grupo tecnico se ha creado exitosamente.'),
      ],
      [
        ActionTypes.ADDED_TECHNICIAN_GROUP_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  });
};

export const updateTechnicianGroup = (data) => {
  return apiActionCreator({
    'endpoint': '/accessories/technician-groups',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_TECHNICIAN_GROUP,
      [
        ActionTypes.UPDATED_TECHNICIAN_GROUP,
        addMessageBoxInfo('El grupo tecnico se ha actualizado exitosamente.'),
      ],
      [
        ActionTypes.UPDATED_TECHNICIAN_GROUP_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': data,
  });
};

export const clearTechnicianGroup = () => ({
  'type': ActionTypes.CLEAR_TECHNICIAN_GROUP,
});
